module.exports = __webpack_public_path__ + "static/media/Prospector.5cc0669f.jpg";